'use client';

import classNames from 'classnames';
import React from 'react';

// Types
import { BoxProps } from '../../types/container/box';

// Services
import { validate } from '../../services/box';

export const Box = (props: BoxProps) => {
  validate(props);

  const {
    id,
    ref,
    type,
    width,
    style,
    addKey,
    border,
    shadow,
    margin,
    padding,
    addFlow,
    addReel,
    addValue,
    addRepel,
    addProse,
    addBlock,
    bgColour,
    children,
    rounding,
    addSrOnly,
    scrollbar,
    component,
    className,
    addSticky,
    horizontal,
    addCluster,
    fontColour,
    addSwitcher,
    addKeyValue,
    borderColour,
    addActionGroup,
    ...otherProps
  } = props;

  const Component = component;

  return (
    <Component
      id={id}
      style={style}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ref={ref as any}
      data-type={type}
      data-scroll={scrollbar === 'snap' ? 'snap' : undefined}
      className={classNames({
        [`${width}`]: width,
        scrollbar: scrollbar,
        [`${shadow}`]: shadow,
        [`${bgColour}`]: bgColour,
        [`${rounding}`]: rounding,
        [`${className}`]: className,
        [`${horizontal}`]: horizontal,
        [`${fontColour}`]: fontColour,
        [`${borderColour}`]: borderColour,

        flow: addFlow,
        reel: addReel,
        repel: addRepel,
        prose: addProse,
        sticky: addSticky,
        cluster: addCluster,
        'p-block': addBlock,
        'sr-only': addSrOnly,
        switcher: addSwitcher,
        'action-group': addActionGroup,

        key: addKey,
        val: addValue,
        'key-val': addKeyValue,

        [`${margin?.m}`]: margin?.m,
        [`${margin?.mb}`]: margin?.mb,
        [`${margin?.ml}`]: margin?.ml,
        [`${margin?.mr}`]: margin?.mr,
        [`${margin?.mt}`]: margin?.mt,
        [`${margin?.my}`]: margin?.my,
        [`${margin?.mx}`]: margin?.mx,

        [`${padding?.p}`]: padding?.p,
        [`${padding?.pb}`]: padding?.pb,
        [`${padding?.pl}`]: padding?.pl,
        [`${padding?.pr}`]: padding?.pr,
        [`${padding?.pt}`]: padding?.pt,
        [`${padding?.py}`]: padding?.py,
        [`${padding?.px}`]: padding?.px,

        [`${border?.x}`]: border?.x,
        [`${border?.y}`]: border?.y,
        [`${border?.top}`]: border?.top,
        [`${border?.left}`]: border?.left,
        [`${border?.right}`]: border?.right,
        [`${border?.bottom}`]: border?.bottom,
        [`${border?.standard}`]: border?.standard,
      })}
      {...otherProps}
    >
      {children}
    </Component>
  );
};

Box.displayName = 'Box';
